const reqUrl = {
  queryPurchaseTaskList: "/apis/scma/ppc/queryPurchaseTaskList",
  qryOrderDetail: "/apis/scma/order/qryOrderDetail",
  queryInfoByCompanyId: "apis/scma/supplier/queryInfoByCompanyId",
  qryDicData: "/apis/bid-scp/bidc/listDictByCode",
  getOrgList: "/apis/scma/org/qryOrgReferTreeService",
  queryEquipmentOrMaterialsPurchasePlanList:
    "apis/scma/ppc/plan/queryEquipmentOrMaterialsPurchasePlanList", //设备/物资采购计划列表查询API
  queryPurchasePlanList: "apis/scma/ppc/plan/queryPurchasePlanList", //采购计划编制列表查询
  addPurchaseTaskPlanList: "apis/scma/ppc/addPurchaseTaskPlanList", //采购任务计划清单新增
  addPurchaseTask: "apis/scma/ppc/addPurchaseTask", //采购任务新增
  queryPurchaseTaskDetail: "apis/scma/ppc/queryPurchaseTaskDetail", //采购任务查询
  queryPurchaseTaskPlanList: "apis/scma/ppc/queryPurchaseTaskPlanList", //采购任务关联计划列表查询
  editPurchaseTask: "apis/scma/ppc/editPurchaseTask", //采购任务修改
  queryPurchaseSchemePlanDetailList:
    "apis/scma/psc/queryPurchaseSchemePlanDetailList", //查询采购方案下的采购计划物资明细列表
  stopPurchaseTask: "apis/scma/ppc/stopPurchaseTask", //采购任务终止API
  queryPurchaseTaskAuditList: "apis/scma/ppc/queryPurchaseTaskAuditList", //采购任务审批列表查询
  queryPurchaseTaskApprovalRecordList:
    "apis/scma/ppc/queryPurchaseTaskApprovalRecordList", //采购任务审批记录列表查询API
  qryApprovalRecord: "/apis/scma/mtc/qryApprovalRecord", //审批记录查询服务接口
  queryPurchaseSchemeTaskRelationList:
    "apis/scma/psc/queryPurchaseSchemeTaskRelationList", //采购方案关联任务查询API
  querySelectablePerson: "apis/scma/ppc/querySelectablePerson",
  queryFrameworkAgreementDetail: "apis/scma/proc/queryFrameworkAgreementDetail", //框架协议详情查询
  // qrylistUserPartJobComInfo: "apis/scpma/org/listUserPartJobComInfo", //查询申请人所属单位及兼职单位列表
  qrylistUserPartJobComInfo: "/apis/bid-scp/bidc/qryUserPartCompanyList", //申请人所属单位及兼职单位列表查询区分供应或采购
  queryPurchasePlanAttachmentList:
    "apis/scma/ppc/plan/queryPurchasePlanAttachmentList", //采购计划详情采购计划详情附件列表
  saveContractByProtocol: "/apis/scma/proc/saveContractByProtocol", //协议生成合同
  queryPurchasePlanApi: "/apis/scma/ppc/plan/queryPurchasePlan", //查询采购计划详情
  qryBidSchemeProcessList: "/apis/scma/bidc/qryBidSchemeProcessList",
  qryTenderOpenList: "/apis/bid-scp/bidc/qryTenderOpenList",
  qryBidOpenUserList: "/apis/bid-scp/bidc/qryBidOpenUserList",
  queryTodomsgDetailById: "/apis/scma/bidc/queryTodomsgDetailById",
  dealTenderOpen: "/apis/bid-scp/bidc/dealTenderOpen",
  qryExpertEvaProjectList: "/apis/scma/bidc/qryExpertEvaProjectList",
  qryExpertEvaProjectCount: "/apis/scma/bidc/qryExpertEvaProjectCount",
  listPageBidTargetApproval: "/apis/scma/bidc/listPageBidTargetApproval",
  dealBiddingApproval: "/apis/scma/bidc/dealBiddingApproval",
  listSelectablePerson: "/apis/scma/bidc/listSelectablePerson",
  queryPurchaseSchemeDetail: "/apis/scma/psc/queryPurchaseSchemeDetail",
  qrySupScailingRegister: "/apis/scma/bidc/qrySupScailingRegister",
  qryFileinfoList: "/apis/scma/bidc/qryFileinfoList",
  qryBidReportDetail: "/apis/scma/bidc/qryBidReportDetail",
  qryBidReportRecommendList: "/apis/bid-scp/bidc/qryBidReportRecommendList",
  qryBidReportExpertConfirmList:
    "/apis/scma/bidc/qryBidReportExpertConfirmList",
  qryBidResultConfirmList: "/apis/scma/bidc/qryBidResultConfirmList",
  dealBidResultConfirm: "/apis/scma/bidc/dealBidResultConfirm",
  qryBidSchemeProcessStatus: "/apis/bid-scp/bidc/qryBidSchemeProcessStatus",
  qrySupComCheckConfirmList: "/apis/scma/bidc/qrySupComCheckConfirmList",
  qrySupPriceHis: "/apis/scma/bidc/qrySupPriceHis",
  qryScailingSplitSupScalingItem:
    "/apis/scma/bidc/qryScailingSplitSupScalingItem",
  qryInspectionCheckSchemeList: "/apis/scma/bidc/qryInspectionCheckSchemeList",
  qryUnitOrgTree: "/apis/scma/org/qryOrgReferTreeService",
  qryCheckSchemeList: "/apis/scma/bidc/qryCheckSchemeList",
  qryBidSchemeProcessStatusScpma: "/apis/scma/bidc/qryBidSchemeProcessStatus",
  listPageSupNoticeApproval: "/apis/scma/bidc/listPageSupNoticeApproval",
  listPageAddendumApproval: "/apis/scma/bidc/listPageAddendumApproval"
};
export default reqUrl;
